import React, {useState, useEffect} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ClubJoueur from '../components/ClubJoueur';
import './Performances.css';
import axios from 'axios';
import { domain } from '../variables';

function Performances() {
    const state = useLocation();
    const navigate = useNavigate();
    const [resultats, setResultats] = useState([]);
    let player = null; let championnat = null;
    

    if (state.state !== null)  {
        player = state.state.player; 
        championnat = state.state.championnat; 
    }
    else {
        navigate('/');
    }

    useEffect(()=> {
        getResults();
    }, []);

    const getResults = async () => {
        const link = domain + '/server/getLivescoringResultats.php';
        await axios.post(
            link, 
            {
                joueur: player.joueur,
            }
        ).then(res => {
            const data = res.data;
            if (res.data instanceof Array) {
                setResultats(data);
            }
        })
    }

    const getWinner = (match) => {
        const points = match.total_points;
        const setsPlayerOne = []; const setsPlayerTwo = [];
        let winOne = 0; let winTwo = 0;

        // On sépare les points de chaque sets
        // entre les deux joueurs
        points.split(';').forEach((item) => {
            item.split(',').forEach((separate, index) => {
                if (index === 0) {
                    setsPlayerOne.push(separate);
                }
                else if (index === 1) {
                    setsPlayerTwo.push(separate);
                }
            })
        })

        

        for (let i = 0; i < setsPlayerOne.length; i++) {
            const value1 = parseInt(setsPlayerOne[i]);
            const value2 = parseInt(setsPlayerTwo[i]);
            if (value1 > value2) {
                winOne++;
            }
            else if (value2 > value1) {
                winTwo++;
            }
        }

        // console.log("SET SET SET SET ET MATCH")
        // console.log(setsPlayerOne + " - " + winOne);
        // console.log(setsPlayerTwo + " - " + winTwo);

        if (winOne === 3 && match.joueur_a.toUpperCase() === player.joueur.toUpperCase()) {
            return "winner";
        }
        
        if (winTwo === 3 && match.joueur_b.toUpperCase() === player.joueur.toUpperCase()) {
            return "winner";
        }

        return '';

        // VICTOIRE BDD CASSE A REPARER ///
        ///////////////////////////////////
        // if (match.statut == "victoire_JA" && match.joueur_a === player.joueur) {
        //     return "winner";
        // }
        // else if (match.statut == "victoire_JB" && match.joueur_b === player.joueur) {
        //     return "winner";
        // }
        // else {
        //     return "";
        // }
    }

    return ( 
        <div className="performances_page">
            {/* // BANNIERE */}
            <div className={"top_banniere " + championnat}>
                <span className="top_banniere_title">
                    Performances de {player.joueur}
                </span>
            </div>
            <div className="performances_content">
                {
                    resultats.map((item, index) => {
                        return (
                            <div key={index}  className="performances_panel">
                                <div className="performances_team">
                                    <span>{item.club_1_name} - {item.club_2_name}</span>
                                </div>
                                <div className="performances_pictures">
                                    <ClubJoueur player={player} championnat={championnat} withInfo={false} />
                                    <span style={{marginRight: 30}}>Contre</span>
                                    <img 
                                        src={process.env.PUBLIC_URL + "/images/players/" + (item.joueur_a.toUpperCase() === player.joueur.toUpperCase() ? item.joueur_b.toUpperCase() : item.joueur_a.toUpperCase()) + ".png"} 
                                        alt="" 
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null; 
                                            currentTarget.src=process.env.PUBLIC_URL + "/images/players/avatar.png";
                                        }}
                                        width="240" 
                                        height="240" 
                                    />
                                </div>
                                <div className="performances_container">
                                    <div className="performances_opponents">
                                        <span className={item.joueur_a.toUpperCase() === player.joueur.toUpperCase() ? 'performances_current' : ""}>{item.joueur_a}</span>
                                        <span className={item.joueur_b.toUpperCase() === player.joueur.toUpperCase() ? 'performances_current' : ""}>{item.joueur_b}</span>
                                    </div>
                                    <div className="performances_points">
                                        {
                                            item.total_points.split(";").map((points, i2) => {
                                                return (
                                                    <div key={i2} className="performances_col_points">
                                                        {
                                                            points !== "0,0" &&
                                                            points.split(',').map((value, i3) => {
                                                                return (
                                                                    <span key={i3}>{value}</span>
                                                                )
                                                            })  
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className={"performances_resultats " + getWinner(item)}></div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default Performances;